export const AiProcessTaskExceptionReasonEnum = {
    INSUFFICIENT_BALANCE: 'insufficient_balance',
    PROHIBITED_CONTENT: 'prohibited_content',
    UNPROCESSABLE_RESPONSE: 'unprocessable_response',
    TECHNICAL_ERROR: 'technical_error'
} as const;

export type AiProcessTaskExceptionReason =
    typeof AiProcessTaskExceptionReasonEnum[keyof typeof AiProcessTaskExceptionReasonEnum];

export function getAiProcessTaskExceptionReasonLabelKey(reason: AiProcessTaskExceptionReason): string {
    return `labels.ai_process_exception_reasons.${reason}`;
}
